export default __webpack_public_path__ + "static/media/average-level-doubles.731e4dd6.svg";